import axios from "axios";
import {pageWidth} from "../functions/windowSizeFunctions";

class Glossary {
    constructor() {
        this.letters = document.querySelectorAll(".glossary__letter");
        this.words = document.querySelectorAll(".glossary__word");
        this.selectedLetter = "A";
        this.wordsList = document.querySelector("#wordsList");
        this.wordsListLength = this.wordsList ? this.wordsList.dataset.tablength : '';
        this.loadMoreBtn = document.querySelector("#loadmore");
        this.shown = 17;
        this.offset = 17;
        this.startIndex = 0;
        this.runHideWords();
        this.events();
    }

    events() {

        window.addEventListener("resize", (e) => pageWidth() < 768 ? this.runHideWords() : '');


        if (this.letters) {
            this.letters.forEach((element) => {
                element.addEventListener("click", (e) => {
                    this.deleteClass("glossary__letter--selected", this.letters);
                    e.target.classList.add("glossary__letter--selected");
                    this.selectedLetter = e.target.dataset.filterby;
                    this.findTerms();
                });
            });
        }

        if (this.words) {
            this.words.forEach((element) => {
                element.addEventListener("click", (e) => {
                    if (!e.currentTarget.classList.contains('open')) {
                        this.deleteClass("open", this.words);
                        e.currentTarget.classList.add("open");
                    } else {
                        e.currentTarget.classList.remove("open");
                    }
                });
            });

        }

        if (this.loadMoreBtn) {
            this.loadMoreBtn.addEventListener("click", (e) => {
                this.showHidden();
                this.hideBtn();
            });
        }

    }

    findTerms() {
        const data = new FormData();
        data.append("action", "getGlossaryTerms");
        data.append("letter", this.selectedLetter);

        axios
            .post(ajax.ajax_url, data)
            .then((res) => {
                this.wordsList.innerHTML = JSON.parse(res.data.data)

                this.words = document.querySelectorAll(".glossary__word");
                this.shown = this.offset;
                this.runHideWords();
                this.words.forEach((element) => {
                    element.addEventListener("click", (e) => {
                        this.deleteClass("open", this.words);
                        e.currentTarget.classList.add("open");
                    });
                });
            })
            .catch((err) => {

            });
    }

    deleteClass(className, object) {
        object.forEach((e) => e.classList.remove(className));
    }

    runHideWords() {
        if (pageWidth() < 768) {
            this.words.forEach((el) => (el.style.display = "none"));
            this.showHidden();
        } else {
            this.words.forEach((el) => (el.style.display = "block"));
        }
    }

    showHidden() {
        if (this.shown <= this.wordsListLength) {
            Array.from(this.words)
                .slice(0, this.shown)
                .forEach((el) => (el.style.display = "block"));
            this.shown = this.shown + this.offset;

        } else if (this.shown >= this.wordsListLength) {
            Array.from(this.words)
                .slice(0, this.wordsListLength)
                .forEach((el) => (el.style.display = "block"));
        }
    }

    hideBtn() {
        if (this.shown >= this.wordsListLength) {
            this.loadMoreBtn.style.display = 'none'
        } else {
            this.loadMoreBtn.style.display = 'flex'
        }
    }
}

export default Glossary;
